<template>
    <div
        class="input-checkbox"
        :class="{ checked: modelValue, disabled, error }"
        @click.prevent="handleCheckToggle"
    >
        <input
            type="checkbox"
            :checked="modelValue"
            :disabled="disabled"
            :tabindex="tabindex"
        />
        <div
            :class="{ checked: modelValue, disabled, error }"
            role="checkbox"
            :aria-checked="modelValue"
        >
            <transition name="checkbox">
                <Check
                    v-if="modelValue"
                    size="15"
                />
            </transition>
        </div>
    </div>
</template>

<script setup lang="ts">
import Check from 'widget-components/assets/svg/Check.vue'

const props = defineProps<{
    modelValue?: boolean
    disabled?: boolean
    error?: boolean
    tabindex?: string
}>()

const emit = defineEmits(['update:modelValue'])

const handleCheckToggle = () => {
    if (props.disabled) {
        return
    }
    emit('update:modelValue', !props.modelValue)
}
</script>

<style scoped lang="sass">
@import './CheckTrigger.sass'
</style>

